import { FlexboxGrid } from 'rsuite';
import { IMAGE_BASE_URL } from '../../../core';
import NoFileImg from '../../../assets/icons/no_file.svg';
import { useNavigate } from 'react-router-dom';
import { FeedModel } from '../../../models/models';
import { useFeed } from '../../../contexts/feed';

interface FeedProps {
  feed: FeedModel[];
}

export const Feed = (props: FeedProps) => {
  const navigate = useNavigate();
  const { setFeed } = useFeed();
  const handleFeedClick = (feed: FeedModel, id: number) => {
    setFeed(feed);
    navigate(`/feed/${id}`);
  };
  return (
    <>
      <FlexboxGrid className=" mt-3">
        {props.feed &&
          props.feed.map((post) => (
            <FlexboxGrid.Item key={post.id} colspan={8}>
              <div className="p-2">
                <div
                  className="rounded-full bg-[--rs-primary-100] aspect-square"
                  onClick={() => handleFeedClick(post, post.id)}>
                  <img src={`${IMAGE_BASE_URL}/${post.image_name}`} alt={post.title} />
                </div>
              </div>
            </FlexboxGrid.Item>
          ))}
      </FlexboxGrid>
      {props.feed?.length === 0 ? (
        <div className="mt-3">
          <img className="mx-auto mb-2" src={NoFileImg} alt="" />
          <p className="text-base text-center">در این دسته بندی هنوز مطلبی منتشر نشده است!</p>
        </div>
      ) : null}
    </>
  );
};
